<template>
  <div>
    <div>
      <van-tabs v-model="active" swipeable color="#07C160"  sticky>
        <van-tab :title="$t('设备信息')"><device-info /></van-tab>
        <van-tab :title="$t('设备设置')"><device-setting /></van-tab>
        <van-tab v-if="!hideOrder" :title="$t('设备指令')"><device-order /></van-tab>
      </van-tabs>
    </div>


  </div>
</template>

<script>
import {Tabs,Tab} from 'vant';
import DeviceSetting from "@/view/setting/index"
import DeviceOrder from "@/view/order/index"
import DeviceInfo from "@/view/device/info/index"
import {setToken} from "@/util/auth";
import {setImei, setSaasId} from "@/util/session-storage-utils";
export default {
  name: "device-index",
  components:{
    [Tabs.name]:Tabs,
    [Tab.name]:Tab,
    [DeviceSetting.name]:DeviceSetting,
    [DeviceOrder.name]:DeviceOrder,
    [DeviceInfo.name]:DeviceInfo
  },
  data(){
    return {
      active:1,
      hideOrder:0,
    };
  },
  created(){
    setToken(this.$route.query._token)
    let imei = this.$route.query._imei;
    setImei(imei)
    let saasId = this.$route.query._saasId;
    setSaasId(saasId)
    if(this.$route.query.tabActive){
      this.active = parseInt(this.$route.query.tabActive)
    }
    if(this.$route.query.hideOrder){
      this.hideOrder = parseInt(this.$route.query.hideOrder)
    }
    document.title = this.$t("设备操作");
    // this.loadData();
  },
}
</script>

<style scoped>

</style>
